<template>
    <section>
        <ui-input
            :value="value"
            :required="required"
            label="CEP"
            placeholder="CEP"
            mask="#####-###"
            @input="validateCep"
        />
    </section>
</template>

<script>
	import { uiInput } from '@/components/ui/form'
	import { offline } from '@/services/axios'

	export default {
		name: 'ui-input-cep',

		components: {
			uiInput
		},

		props: {
			/**
			* define o input como required em html5 e aplica o operador '*' na label
			*/
			required: {
				type: Boolean,
				required: false,
				default: false
			},
			value: {
				type: null,
				required: false,
				default: ''
			}
		},

		data () {
			return {
				requesting: false
			}
		},

		methods: {
			validateCep(value) {
				if(value.length == 9 && !this.requesting) {
					this.requesting = true
				offline.cep(value).then(response => {
					if(this.isObjectEmpty(response.data)) throw new Error('CEP Inválido!')
					this.$emit('input', { cep: value, data: { ...response.data } })
				}).catch (e => {
					this.$toastr.e(e)
				})
			}
				if(value.length < 9) this.requesting = false
			},
			isObjectEmpty(value) {
				return Object.keys(value).length === 0
			}
		}
	}
</script>